












import { MtbPromoSticker } from '@interfaces/hybris/MtbPromoSticker';
import Vue, { PropType } from 'vue';

export default Vue.extend({
	name: 'Stickers',
	props: {
		promoStickers: {
			required: true,
			type: Array as PropType<MtbPromoSticker[]>,
		},
	},
	filters: {
		bgStyles(sticker: MtbPromoSticker): Partial<CSSStyleDeclaration> {
			return {
				backgroundColor: sticker.color,
			};
		},
	},
});
